import { Loader, MultiSelect } from '@mantine/core';
import { IconMessage2 } from '@tabler/icons-react';

import { useGetProphetRules } from '@/features/prophet';

type Props = {
  value?: string[];
  onSelect: (value: string[]) => any;
  required?: boolean;
  pageId?: string;
};

export const RulesSelect = ({ value, onSelect, required, pageId }: Props) => {
  const { data, isFetching: isLoading } = useGetProphetRules({ pageId });
  const rules = data?.rules || [];
  const options = rules.map((rule) => ({
    value: rule._id,
    label: rule.keyword || 'Стандартное правило',
  }));
  return (
    <MultiSelect
      required={required}
      value={value}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      data={options}
      placeholder="Pick rules to clone"
      searchable
      rightSection={isLoading ? <Loader size="xs" /> : null}
      leftSection={<IconMessage2 size="1rem" />}
      onChange={(value) => value && onSelect(value)}
    />
  );
};
